import Grid from '@mui/material/Grid';
import Section from '@shared/components/Section';
import { FC } from 'react';

import { useConfigContext } from '../context/ConfigContext';
import FooterLegal from './FooterLegal';
import FooterLinkGroup from './FooterLinkGroup';
import FooterSocial from './FooterSocial';

const Footer: FC = () => {
  const { footer } = useConfigContext();

  return (
    <footer>
      <Section padding={{ bottom: '0' }}>
        <Grid container spacing={{ lg: '2rem', md: '0.5rem', xs: '2rem' }}>
          {footer.map(group => (
            <Grid key={group.text} size={{ md: 3, xs: 12 }}>
              <FooterLinkGroup group={group} key={group.text} />
            </Grid>
          ))}
        </Grid>
      </Section>

      <Section>
        <FooterLegal />
        <FooterSocial />
      </Section>
    </footer>
  );
};

export default Footer;
